import React from 'react'
import PropTypes from 'prop-types'
import { colours, sizes } from '@qflow/theme'

export function Cross({
  size = sizes.LARGER,
  colour = colours.BLACK,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="28"
      viewBox="0 0 26 28"
      style={{ width: size, height: size }}
      {...props}
    >
      <defs>
        <path
          id="a"
          d="M15.0807 13.9981L25.6275 1.42624C25.8043 1.21731 25.6557 0.899902 25.3824 0.899902H22.1762C21.9874 0.899902 21.8066 0.984277 21.682 1.12892L12.9833 11.499L4.28468 1.12892C4.16414 0.984277 3.98334 0.899902 3.79048 0.899902H0.584232C0.311018 0.899902 0.162357 1.21731 0.339143 1.42624L10.886 13.9981L0.339143 26.57C0.299541 26.6166 0.274135 26.6735 0.26594 26.7341C0.257745 26.7947 0.267106 26.8563 0.292911 26.9118C0.318716 26.9672 0.359882 27.014 0.411521 27.0467C0.46316 27.0795 0.523102 27.0967 0.584232 27.0963H3.79048C3.97932 27.0963 4.16013 27.012 4.28468 26.8673L12.9833 16.4972L21.682 26.8673C21.8025 27.012 21.9833 27.0963 22.1762 27.0963H25.3824C25.6557 27.0963 25.8043 26.7789 25.6275 26.57L15.0807 13.9981Z"
        />
      </defs>
      <use fill={colour || colours.BLACK} fillRule="nonzero" xlinkHref="#a" />
    </svg>
  )
}

Cross.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
